function renderVariantImages(variant) {
    const colorOptionIndexHolder = document.querySelector('[data-color-option-index]');
    if(!colorOptionIndexHolder) return;
    const colorOptionIndex = colorOptionIndexHolder.getAttribute('data-color-option-index') * 1;
    const colorVariant = variant.options[colorOptionIndex]
    const images = document.querySelectorAll('.product-image-for-js');

    images.forEach((image) => {
        if(image.alt.trim === '' || image.alt.includes(colorVariant)){
            findAncestor(image, 'swiper-slide').classList.remove('hidden');
        }
        else {
            findAncestor(image, 'swiper-slide').classList.add('hidden');
        }
    });
}

function findAncestor (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
}